<!-- <p>Value:
  <input type="number" [(ngModel)]="value">
</p> -->

<div [formGroup]="parent" class="col-sm-12 form-field has-error"
  [ngClass]="{'content-wrapper':!defaultStyle,'clear-all':defaultStyle, 'opacity':(!enableTooltip ? disable : false), 'pointer-events-none':(!enableTooltip ? disable : false)}">
  <p *ngIf="sliderConfig.sliderTitleVisible" class="margint-8"
    [ngClass]="{'form-label-fullwidth':defaultStyle, 'opacity':disable}" [innerHTML]="sliderConfig.sliderTitle"
    [id]="sliderId+'-header'"></p>
  <div
    [ngClass]="{'margint-30':(sliderConfig.sliderTitleVisible || sliderConfig.sliderType === 'Months' || !(sliderConfig.sliderTitleVisible))}"
    class="row">
    <div class="row flex-container w-300">
      <div class="margin-top-3 text-center right-pad-0">
        <span [ngClass]="{'opacity':disable}" *ngIf="sliderConfig.sliderTypeVisible" class="standfirst font-18"
          [id]="sliderId+sliderConfig.sliderType">
          <span>{{sliderConfig.sliderType}}{{(!sliderConfig.unselectedByDefault)? ':&thinsp;':''}}</span>
          <i [id]="sliderId+'-value'" *ngIf="!sliderConfig.unselectedByDefault">{{calculatedValueLumpSum}}</i>
          <!-- {{sliderConfig.sliderType==='Percentage'?'%':null}} -->
        </span>

      </div>
      <div class="col-md-2 left-pad-0" *ngIf="sliderConfig.infoIconFlag">
        <app-tool-tip-notification [childId]="sliderId" [tooltipName]="controlName+'_tooltip'" class="col-sm-1"
          [disable]="!enableTooltip ? disable : false" [tooltipData]="sliderConfig.infoIconData"
          (goToDependatsTTEmitter)="goToDependantsPageSS()"
          (onDisplayMobileTooltipEmitter)="displayMobileTooltipSliderReceiver()"></app-tool-tip-notification>
      </div>
    </div>
    <div
      [ngClass]="{'custom-slider-default': sliderConfig.unselectedByDefault, 'custom-slider': !sliderConfig.unselectedByDefault}">
      <ng5-slider [ngClass]="{'opacity':disable}" [id]="sliderId" (userChange)="calculate(value,sliderConfig)"
        class="margin-top-30" [(value)]="value" [options]="options" [formControlName]="controlName"
        (userChangeEnd)="onUserChangeEnd($event, sliderConfig, controlName)"></ng5-slider>
    </div>
    <ng-content select=".textUnderSlider" style="margin-top: 40px;">

    </ng-content>
    <div class="row">
      <div [id]="controlName+'-error'" class="col-md-12 form-validation-error margin-top-40 width-100" *ngIf="parent.get(controlName).touched
      &&
      parent.get(controlName).errors && (parent.get(controlName).errors.customErrorMessage || parent.get(controlName).errors.zeroAmount || sliderConfig.unselectedByDefault
      || parent.get(controlName).errors.invalidLTAMin)">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p *ngIf="sliderConfig.unselectedByDefault">{{sliderConfig.validationMsg}}
        </p>
        <p *ngIf="parent.get(controlName).errors.zeroAmount">{{sliderConfig.zeroValidationMsg}}
        </p>
        <p *ngIf="parent.get(controlName).errors.customErrorMessage">{{sliderConfig.customErrorMessage}}
        </p>
        <p *ngIf="parent.get(controlName).errors.invalidLTAMin">{{setMinLTA(sliderConfig.invalidLTAMinMsg)}}
        </p>
      </div>
    </div>
    <!-- <app-tool-tip-notification [tooltipName]="controlName+'_tooltip'" *ngIf="questionConfig.infoIconFlag" class="col-sm-1" [tooltipData]="questionConfig.infoIconData"></app-tool-tip-notification> -->
  </div>

  <!-- <div *ngIf="questionInfo && questionInfo !== ''" class="question-info col-md-12 p-0 margin-top-error" [ngClass]="questionInfoClass">
    <p [innerHTML]="questionInfo"></p>
  </div> -->
</div>